import React from 'react'

import { string } from 'prop-types'

function UseCaseUserInfo({ username, avatarUrl = null }) {
  return (
      <div className="use-case-info__item">
      <span className="use-case-info__item-title cgt-legacy-text-caption">Created by</span>
      <div className="use-case-info__item-value">
        {avatarUrl ? (
          <div className="use-case-info__item-avatar">
            <img
              src={avatarUrl}
              alt={username}
              className="use-case-info__item-avatar-img"
            />
          </div>
        ) : null}

        <a
          href={`/designers/${username}`}
          target="_blank"
          rel="noopener noreferrer"
          className="use-case-info__item-username">
          {username}
        </a>
      </div>
    </div>
  )
}

UseCaseUserInfo.propTypes = {
  username: string.isRequired,
  avatarUrl: string,
}

export default UseCaseUserInfo
